"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const urls_1 = __importDefault(require("./urls"));
const mapPlaybackReportResponse = (pr) => ({
    id: pr.id,
    profileId: pr.profile_id,
    createdAt: pr.created_at,
    status: pr.status,
    name: pr.name,
    deviceIds: pr.device_ids,
    start: pr.start,
    end: pr.end,
    rowsPerPage: pr.rows_per_page,
    destinationBucket: pr.destination_bucket,
    error: pr.error,
    r: {
        playbackReportFiles: (pr.r.playback_report_files || []).map((prf) => ({
            createdAt: prf.created_at,
            pageNumber: prf.page_number,
            destinationKey: prf.destination_key,
        })),
    },
});
class PlaybackReportClient {
    getPlaybackReports() {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'GET',
                url: urls_1.default.playbackReports(),
            });
            return data.map(mapPlaybackReportResponse);
        });
    }
    generatePlaybackReport(body) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'POST',
                url: urls_1.default.playbackReports(),
                body: {
                    device_ids: body.deviceIds,
                    name: body.name,
                    start: body.start,
                    end: body.end,
                    rows_per_page: body.rowsPerPage,
                },
            });
            return mapPlaybackReportResponse(data);
        });
    }
}
exports.default = PlaybackReportClient;
